// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"330":"f060ed6f","346":"ab82233d","364":"89fb163d","626":"f060ed6f"}[chunkId] + ".chunk.css";
};